import React, {useEffect, useMemo, useRef, useState} from "react";
import * as Sentry from '@sentry/browser';
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import Pagination from "react-js-pagination";
import {Select} from "../../Components/Utils/FieldsHelper";
import DateRange from "../../Components/Utils/DateRange";
import classes from "./styles.module.css";

const ALL_PROJECT_OPTION = {uuid: "all", name: "Все мерчанты"};

const Frod = withAuth(({token}) => {
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);

    const [filterDate, setFilterDate] = useState(null);
    const [idFilter, setIdFilter] = useState("");
    const [transactionFilter, setTransactionFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [ipFilter, setIpFilter] = useState("");

    const [frodData, setFrodData] = useState({items: [], total: 0});
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const itemsPerPage = 10;

    const dateInitHandledRef = useRef(false);

    const STATUS_LABELS = {
        ATTEMPT_CREATED: "Попытка создана",
        BLOCK_TEMP: "Временная блок.",
        BLOCK_PERM: "Перманентная блок.",
        BLOCK_ACTIVE_PERM: "Активная перм. блок.",
    };

    useEffect(() => {
        new Api({token})
            .getProjectsList({page: 1, itemsPerPage: 1000, order: "DESC"})
            .then(r => {
                if (r && r.data) {
                    const list = [ALL_PROJECT_OPTION, ...r.data];
                    setProjects(list);
                    setSelectedProject(prev => prev || ALL_PROJECT_OPTION);
                }
            })
            .catch(err => { Sentry.captureException(err); console.error(err); });
    }, [token]);

    const buildRequestBody = () => {
        const filters = [];

        if (ipFilter.trim()) {
            filters.push({field: "clientIp", value: ipFilter.trim()});
        }
        if (idFilter.trim()) {
            filters.push({field: "id", value: idFilter.trim()});
        }
        if (transactionFilter.trim()) {
            filters.push({field: "transactionId", value: transactionFilter.trim()});
        }
        if (statusFilter) {
            filters.push({field: "status", value: statusFilter});
        }

        const body = {
            filters,
            itemsPerPage,
            page
        };

        if (filterDate && filterDate.startDate && filterDate.endDate) {
            body.dateRange = {
                startDate: filterDate.startDate,
                endDate: filterDate.endDate
            };
        }

        return body;
    };

    const isAllMerchants =
        selectedProject && selectedProject.uuid === ALL_PROJECT_OPTION.uuid;

    const handleDateChange = (range) => {
        if (!dateInitHandledRef.current) {
            dateInitHandledRef.current = true;
            return;
        }
        setFilterDate(range);
    };

    useEffect(() => {
        if (!selectedProject) {
            return;
        }

        let cancelled = false;
        setLoading(true);

        const body = buildRequestBody();
        const api = new Api({token});
        const uuid = isAllMerchants ? ALL_PROJECT_OPTION.uuid : selectedProject.uuid;

        api.postFrodList(uuid, body)
            .then(res => {
                if (cancelled) return;

                if (res && res.items !== undefined && res.total !== undefined) {
                    setFrodData({items: res.items, total: res.total});
                } else {
                    setFrodData({items: [], total: 0});
                }
            })
            .catch(err => {
                if (cancelled) return;
                Sentry.captureException(err);
                console.error(err);
                setFrodData({items: [], total: 0});
            })
            .finally(() => {
                if (cancelled) return;
                setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [
        selectedProject,
        token,
        page,
        filterDate,
        idFilter,
        transactionFilter,
        statusFilter,
        ipFilter
    ]);

    useEffect(() => {
        setPage(1);
    }, [filterDate, idFilter, transactionFilter, statusFilter, ipFilter, selectedProject]);

    const formatDate = (date) => {
        if (!date) return "—";
        return new Date(date).toLocaleString("ru-RU");
    };

    const projectName = selectedProject ? (selectedProject.name || selectedProject.uuid) : "";

    const statusOptions = [
        {value: "", label: "Все статусы"},
        {value: "ATTEMPT_CREATED", label: STATUS_LABELS["ATTEMPT_CREATED"]},
        {value: "BLOCK_TEMP", label: STATUS_LABELS["BLOCK_TEMP"]},
        {value: "BLOCK_PERM", label: STATUS_LABELS["BLOCK_PERM"]},
        {value: "BLOCK_ACTIVE_PERM", label: STATUS_LABELS["BLOCK_ACTIVE_PERM"]},
    ];

    const projectMap = useMemo(() => {
        const map = {};
        projects.forEach(proj => {
            if (proj.uuid && proj.uuid !== "all") {
                map[proj.id] = proj.name || proj.id;
            }
        });
        return map;
    }, [projects]);

    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={1180}>
                        <div className={classes.PageContent}>

                            <div
                                className={classes.FiltersGrid}
                            >
                                <div>
                                    {/* DateRange больше не сможет перетереть данные на первом вызове */}
                                    <DateRange
                                        onSelectDate={handleDateChange}
                                    />
                                </div>

                                <div>
                                    <h6 className={classes.Title}>
                                        ID записи
                                    </h6>
                                    <input
                                        type="text"
                                        value={idFilter}
                                        onChange={e => setIdFilter(e.target.value)}
                                        placeholder="Например: 12345"
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            border: "1px solid #ddd",
                                            borderRadius: "4px"
                                        }}
                                    />
                                </div>

                                <div>
                                    <h6 className={classes.Title}>
                                        ID транзакции
                                    </h6>
                                    <input
                                        type="text"
                                        value={transactionFilter}
                                        onChange={e => setTransactionFilter(e.target.value)}
                                        placeholder="Например: trx_abc123"
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            border: "1px solid #ddd",
                                            borderRadius: "4px"
                                        }}
                                    />
                                </div>

                                <div>
                                    <h6 className={classes.Title}>
                                        IP-адрес
                                    </h6>
                                    <input
                                        type="text"
                                        value={ipFilter}
                                        onChange={e => setIpFilter(e.target.value)}
                                        placeholder="185.123.45.67"
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            border: "1px solid #ddd",
                                            borderRadius: "4px"
                                        }}
                                    />
                                </div>

                                <div>
                                    <h6 className={classes.Title}>
                                        Статус
                                    </h6>
                                    <select
                                        value={statusFilter}
                                        onChange={e => setStatusFilter(e.target.value)}
                                        style={{
                                            width: "100%",
                                            padding: "8px 12px",
                                            border: "1px solid #ddd",
                                            borderRadius: "4px"
                                        }}
                                    >
                                        {statusOptions.map(opt => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <Select
                                        label="FieldsHelper.label.project"
                                        placeholder="FieldsHelper.label.selectProject"
                                        values={projects}
                                        onChange={project => {
                                            setSelectedProject(project || ALL_PROJECT_OPTION);
                                            setFilterDate(null);
                                            setIdFilter("");
                                            setTransactionFilter("");
                                            setStatusFilter("");
                                            setIpFilter("");
                                        }}
                                        selectedValue={selectedProject}
                                        fieldName="name"
                                        isLoading={projects.length === 0}
                                    />
                                </div>

                                <div className={classes.FilterAction}>
                                    <button
                                        onClick={() => {
                                            setFilterDate(null);
                                            setIdFilter("");
                                            setTransactionFilter("");
                                            setIpFilter("");
                                            setStatusFilter("");
                                        }}
                                        className={classes.ClearButton}
                                    >
                                        Очистить все фильтры
                                    </button>
                                </div>
                            </div>

                            <div className={classes.Card}>
                                <div className={classes.Header}>
                                    <h5 className={classes.Title}>
                                        Логи антифрода {projectName && `: ${projectName}`}
                                    </h5>
                                    <div style={{fontSize: "14px", color: "#555"}}>
                                        Найдено: <strong>{frodData.total.toLocaleString("ru-RU")}</strong>
                                    </div>
                                </div>

                                {loading ? (
                                    <div className={classes.Loader}>Загрузка данных...</div>
                                ) : frodData.items.length === 0 ? (
                                    <div className={classes.Empty}>
                                        Нет записей по заданным фильтрам
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <div className={classes.TableScroll}>
                                            <table
                                                className={classes.FrodTable}
                                            >
                                                <colgroup>
                                                    <col style={{width: "70px"}}/>
                                                    <col style={{width: "140px"}}/>
                                                    <col style={{width: "110px"}}/>
                                                    <col style={{width: "90px"}}/>
                                                    <col style={{width: "auto"}}/>
                                                    <col style={{width: "160px"}}/>
                                                    <col style={{width: "160px"}}/>
                                                </colgroup>
                                                <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>IP клиента</th>
                                                    <th>Проект</th>
                                                    <th>Транзакция</th>
                                                    <th>Статус</th>
                                                    <th>Причина</th>
                                                    <th>Заблокирован до</th>
                                                    <th>Создано</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {frodData.items.map(row => {
                                                    const reason = row.reason || "";
                                                    const shortReason =
                                                        reason.length > 120
                                                            ? reason.substring(0, 120) + "..."
                                                            : reason || "—";

                                                    const projectDisplayName = row.merchantId
                                                        ? (projectMap[row.merchantId] || row.merchantId)
                                                        : "—";

                                                    return (
                                                        <tr key={row.id}>
                                                            <td>{row.id}</td>
                                                            <td>{row.clientIp || "—"}</td>
                                                            <td>{projectDisplayName}</td>
                                                            <td>{row.transactionId || "—"}</td>
                                                            <td>
                                                            <span
                                                                className={`${classes.Status} ${
                                                                    classes[row.status] || ""
                                                                }`}
                                                            >
                                                                {STATUS_LABELS[row.status] || "—"}
                                                            </span>
                                                            </td>
                                                            <td title={reason}>{shortReason}</td>
                                                            <td>{formatDate(row.blockedUntil)}</td>
                                                            <td>{formatDate(row.createdAt)}</td>
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {frodData.total > itemsPerPage && (
                                            <div className={classes.PaginationWrap}>
                                                <Pagination
                                                    activePage={page}
                                                    itemsCountPerPage={itemsPerPage}
                                                    totalItemsCount={frodData.total}
                                                    pageRangeDisplayed={5}
                                                    onChange={setPage}
                                                    firstPageText="⇤"
                                                    prevPageText="⇠"
                                                    nextPageText="⇢"
                                                    lastPageText="⇥"
                                                    activeLinkClass={classes.ActiveLink}
                                                />
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                </Column>
            </Container>
        </Wrapper>
    );
});

export default Frod;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/Frod/index.js